import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { Icon } from "@iconify/react";
import * as styles from "../styles/topbar.module.css";
import { Link } from "gatsby";
import LanguageOptions from "./LanguageOptions";
import { useTranslation } from "gatsby-plugin-react-i18next";

export default function Topbar({ alternateLinks, removeLanguages }) {
  const { t } = useTranslation();
  const data = useStaticQuery(graphql`
    query SiteInfo {
      metaData: site {
        siteMetadata {
          email
          linkedinLink
          phoneDisplay
          phoneLink
          xingLink
        }
      }
    }
  `);
  const languageLinks = alternateLinks ? alternateLinks : LanguageOptions();
  const { email, linkedinLink, phoneDisplay, phoneLink, xingLink } =
    data.metaData.siteMetadata;

  return (
    <section
      className={`${styles.topbar} d-flex align-items-center container onlyDesktop`}
    >
      <div
        className={` contactInfo container d-flex justify-content-center justify-content-md-between`}
      >
        <div className={`${styles.contactInfo} d-flex align-items-center`}>
          <Icon icon="bi:envelope" className="d-flex align-items-center" />
          <a href={"mailto:" + email}>{email}</a>
          <span></span>
          <Icon
            icon="bi:telephone-forward"
            className="d-flex align-items-center"
          />
          <a href={phoneLink}>{phoneDisplay}</a>
        </div>
        <div
          className={`${styles.socialLinks}  d-none d-md-flex align-items-center`}
        >
          {!removeLanguages &&
            languageLinks.map((language, i) => {
              return (
                <Link
                  id="topbar"
                  key={i + "-languages"}
                  to={language.to}
                  language={language.language}
                >
                  {language.language.toUpperCase()}
                </Link>
              );
            })}
          <a
            id="topbar"
            href={xingLink}
            aria-label={"Xing " + t("Profil")}
            alt={"Xing " + t("Profil")}
          >
            <Icon
              icon="icomoon-free:xing"
              title={"Xing " + t("Profil")}
              alt={"Xing " + t("Profil")}
            />
            <span className="sr-only">{"Xing " + t("Profil")}</span>
          </a>
          <a
            id="topbar"
            href={linkedinLink}
            aria-label={"LinkedIn " + t("Profil")}
            alt={"LinkedIn " + t("Profil")}
          >
            <Icon
              icon="bi:linkedin"
              title={"LinkedIn " + t("Profil")}
              alt={"LinkedIn " + t("Profil")}
            />
            <span className="sr-only">{"LinkedIn " + t("Profil")}</span>
          </a>
        </div>
      </div>
    </section>
  );
}
